import { render, staticRenderFns } from "./AttemptsWilayas.vue?vue&type=template&id=1e2884a3"
import script from "./AttemptsWilayas.vue?vue&type=script&lang=js"
export * from "./AttemptsWilayas.vue?vue&type=script&lang=js"
import style0 from "./AttemptsWilayas.vue?vue&type=style&index=0&id=1e2884a3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports